import React, { useState, useEffect, useMemo } from "react";
import fetchProducts from "../lib/productUtils";
import { getCategoryDisplayName } from "../lib/getCategoryName";
import { UserAuth } from "../Context";
import useBrandProducts from "../StatesStore/brandProducts";
import useBrandFilter from "../StatesStore/BrandFilters";
import useLogActivity from "../hooks/user/useLogActivity";
import LoadingSpinner from "../UserProfile/LoadingSpinner";
import ProductCardBrandsPage from "../Products/ProductCardBrandsPage";
import {
  ArrowDownUp,
  ChevronDown,
  Filter,
  Funnel,
} from "react-bootstrap-icons";
import { Slider, InputNumber } from "antd";
import {
  doc,
  getDoc,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import { db } from "../FirebaseConfig";
import { Accordion, Button, Modal } from "react-bootstrap";
import Skeleton from "../Products/Skeleton";
import BrandProductsSkeleton from "./BrandProductsSkeleton";
import ProductCard6 from "../Products/ProductCard6";
import ProductCard9 from "../Products/ProductCard9";
import BottomTray from "../Trays/BottomTray";
import FilterTray from "../Trays/FilterTray";
import FilterModal from "./FilterModal";

function BrandProducts3({ brandName, brandInfo }) {
  const setBrandProduct = useBrandProducts((state) => state.setBrandProduct);
  const { BrandFilter, setBrandFilter } = useBrandFilter();

  const { user } = UserAuth();

  const { logActivity } = useLogActivity(user?.uid);

  const [allProducts, setAllProducts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(15);
  const [bname, setBname] = useState("");
  const [lastVisible, setLastVisible] = useState(null);
  const [loading, setLoading] = useState(false);
  const [countLeft, setCountLeft] = useState(true);
  const [prevSubCategory, setPrevSubCategory] = useState(null);
  const [prevSubSubCategory, setPrevSubSubCategory] = useState(null);
  const [columnCount, setColumnCount] = useState(getColumnCount());

  const sortOptions = [
    { value: "NF", name: "Newest First" },
    { value: "PL", name: "Price - Low to High" },
    { value: "PH", name: "Price - High to Low" },
    { value: "DL", name: "Discount - Low to High" },
    { value: "DH", name: "Discount - High to Low" },
  ];

  const [availableGenders, setAvailableGenders] = useState(
    brandInfo?.category || []
  );
  const [subSubCategory, setSubSubCategory] = useState([]);
  const [displaySubCatMap, setDisplaySubCatMap] = useState({});
  const [alphabeticSizes, setAlphabeticSizes] = useState([]);
  const [numericSizes, setNumericSizes] = useState([]);
  const [availableSizes, setAvailableSizes] = useState([]);
  const [colors, setColors] = useState(brandInfo?.colors || []);
  const [pieces, setPieces] = useState(brandInfo?.pieces || []);
  const [showModal, setShowModal] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const [filterOption, setFilterOption] = useState("gender");
  const [allSubSubCategory, setAllSubSubCategory] = useState([]);

  //filters
  const [gender, setGender] = useState([]);
  const [category, setCategory] = useState([]);
  const [subCategory, setSubCategory] = useState([]);
  const [range, setRange] = useState([0, 90000]); // Initial value set to [0, 90000]
  const [size, setSize] = useState([]);
  const [piece, setPiece] = useState([]);
  const [color, setColor] = useState([]);
  const [sortBy, setSortBy] = useState("NF");

  const [showTray, setShowTray] = useState(false);

  const handleClose = () => {
    setShowTray(false);
    setShowModal(false);
    setGender(BrandFilter.category);
    setCategory(BrandFilter.subCategory);
    setSubCategory(BrandFilter.subSubCategory);
    setRange([BrandFilter.minprice, BrandFilter.maxprice]);
    setSize(BrandFilter.size);
  };
  const handleGenderChange = (genderProp) => {
    if (gender.includes(genderProp)) {
      setGender(gender.filter((g) => g !== genderProp));
    } else {
      setGender([...gender, genderProp]);
    }
  };
  const handleCategoryChange = (categoryProp) => {
    if (category.includes(categoryProp)) {
      setCategory(category.filter((g) => g !== categoryProp));
    } else {
      setCategory([...category, categoryProp]);
    }
  };
  const handleSubCategoryChange = (subCat) => {
    if (subCategory.includes(subCat)) {
      setSubCategory(subCategory.filter((g) => g !== subCat));
    } else {
      setSubCategory([...subCategory, subCat]);
    }
  };
  // Function to handle changes in the slider value
  const handleRangeChange = (newRange) => {
    setRange(newRange);
  };

  // Function to handle changes in the min value input box
  const handleMinInputChange = (value) => {
    const newRange = [value, range[1]];
    setRange(newRange);
  };

  // Function to handle changes in the max value input box
  const handleMaxInputChange = (value) => {
    const newRange = [range[0], value];
    setRange(newRange);
  };

  const handleSizeChange = (sizeProp) => {
    if (size.includes(sizeProp)) {
      setSize(size.filter((g) => g !== sizeProp));
    } else {
      setSize([...size, sizeProp]);
    }
  };
  const handlePieceChange = (pieceProp) => {
    if (piece.includes(pieceProp)) {
      setPiece(piece.filter((g) => g !== pieceProp));
    } else {
      setPiece([...piece, pieceProp]);
    }
  };

  const handleColorChange = (colorProp) => {
    if (color.includes(colorProp)) {
      setColor(color.filter((g) => g !== colorProp));
    } else {
      setColor([...color, colorProp]);
    }
  };

  function getColumnCount() {
    const screenWidth = window.innerWidth;
    let count = 2;
    if (screenWidth >= 440) {
      count = 3;
    }
    if (screenWidth >= 768) {
      count = 4;
    }
    if (screenWidth >= 900) {
      count = 5;
    }
    return count;
  }

  const filteredProducts = allProducts;

  const resetBrandFilter = () => {
    handleClose();
    setBrandFilter({
      brand: [],
      color: [],
      size: [],
      piece:[],
      category: [],
      subCategory: [],
      subSubCategory: [],
      minprice: 0,
      maxprice: 90000,
    });
    setGender([]);
    setCategory([]);
    setSubCategory([]);
    setRange([0, 90000]);
    setSize([]);
    setPiece([]);
    setColor([]);
    setSortBy("NF");
  };

  const handleApplyFilter = () => {
    setBrandFilter({
      brand: [],
      color: color,
      size: size,
      piece: piece,
      category: gender,
      subCategory: category,
      subSubCategory: subCategory,
      minprice: range[0],
      maxprice: range[1],
    });
  };

  useEffect(() => {
    function handleResize() {
      setColumnCount(getColumnCount());
      setIsSmallScreen(window.innerWidth < 768);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    if (!brandName) return;
    const fetchSubSubCategories = async () => {
      try {
        const subSubCategories = brandInfo?.subSubCategory;
        setAllSubSubCategory(subSubCategories);

        const subSubCategorySet = new Set();
        const displaySubCatMap = {};

        subSubCategories.forEach((data) => {
          if (data?.subSubCategory && data?.subSubCategory !== "None") {
            subSubCategorySet.add(data?.subSubCategory);
            displaySubCatMap[data?.subSubCategory] =
              data?.subSubCategoryDisplayName;
          }
        });

        // Sort subSubCategorySet
        const sortedSubSubCategory = Array.from(subSubCategorySet).sort(
          (a, b) => {
            const aIsNumeric = !isNaN(a);
            const bIsNumeric = !isNaN(b);

            if (aIsNumeric && bIsNumeric) {
              return a - b; // both are numbers
            } else if (aIsNumeric) {
              return -1; // a is a number, b is a string
            } else if (bIsNumeric) {
              return 1; // a is a string, b is a number
            } else {
              return a.localeCompare(b); // both are strings
            }
          }
        );
        setSubSubCategory(sortedSubSubCategory);
        setDisplaySubCatMap(displaySubCatMap);
      } catch (error) {
        console.error("Error fetching subSubCategory:", error);
      }
    };
    const fetchSizes = async () => {
      try {
        const sizesCollectionRef = collection(db, "sizes");
        const sizesSnapshot = await getDocs(sizesCollectionRef);

        let alphabeticSizes = [];
        let numericSizes = [];

        sizesSnapshot.forEach((doc) => {
          const data = doc.data();
          if (doc.id === "type1") {
            alphabeticSizes = data?.Alphabetic;
          } else if (doc.id === "type2") {
            numericSizes = data?.Numbers;
          }
        });

        setAlphabeticSizes(alphabeticSizes);
        setNumericSizes(numericSizes);

        if (brandName) {
          const brandDocRef = doc(db, "brands", brandName);
          const brandDoc = await getDoc(brandDocRef);
          if (brandDoc.exists()) {
            setAvailableSizes(brandDoc.data().sizes || []);
          } else {
            console.error("No such brand!");
          }
        }
      } catch (error) {
        console.error("Error fetching sizes:", error);
      }
    };
    fetchSubSubCategories();
    fetchSizes();
  }, [brandName]);
  useEffect(() => {
    setCurrentPage(1);
    setAllProducts([]);
    setBrandProduct([]);
    setLastVisible(null);
    setCountLeft(true);
    window.scrollTo(0, 0);

    const activityData = {
      brand: brandName,
      type: "viewedBrand",
    };

    logActivity(activityData);
  }, [bname, subSubCategory,BrandFilter]);
  useEffect(() => {
    // Reset lastVisible and count when category changes
    if (subSubCategory !== prevSubSubCategory) {
      setLastVisible(null);
      setCountLeft(true);
    }

    // Update prevSubCategory and prevSubSubCategory
    setPrevSubSubCategory(subSubCategory);
  }, [subSubCategory, countLeft]);
  useEffect(() => {
    console.log("Brand Filter", BrandFilter);
    setBname(brandName);

    // const queryParams = new URLSearchParams(window.location.search);
    // const sizes = queryParams.get('size') ? queryParams.get('size').split(',') : [];
    // console.log("sizes",sizes);
    fetchProducts({
      activeBrands: [],
      brandName: [brandName],
      category: BrandFilter.category,
      subCategory: BrandFilter.subCategory,
      subSubCategory: BrandFilter.subSubCategory || subSubCategory,
      prevSubSubCategory,
      prevSubCategory,
      lastVisible,
      currentPage,
      setAllProducts,
      setLoading,
      setLastVisible,
      setCountLeft,
      sortBy,
      sizes: BrandFilter.size,
      pieces: BrandFilter.piece,
      colors: BrandFilter.color,
      minprice: BrandFilter.minprice,
      maxprice: BrandFilter.maxprice,
    });
  }, [brandName, BrandFilter, subSubCategory, currentPage, sortBy]);

  const BrandFilterOption = (filterOption, text) => {
    return (
      <div
        style={{
          cursor: "pointer",
          height: isSmallScreen ? "28px" : "40px",
          padding: isSmallScreen ? "10px 16px" : "10px 24px",
          gap: "10px",
          borderRadius: isSmallScreen ? "8px" : "12px",
          borderWidth: "1px",
          border: "1px solid #C3C3C3",
        }}
        className="d-flex align-items-center justify-content-center"
        onClick={() => {
          if (isSmallScreen) {
            setShowTray(true);
          } else {
            setShowModal(true);
          }
          setFilterOption(filterOption);
        }}
      >
        <div
          style={{
            fontFamily: "Inter",
            fontWeight: "400",
            fontSize: "14px",
            lineHeight: "100%",
            letterSpacing: "0%",
            color: "#676A79",
            whiteSpace: "nowrap",
          }}
        >
          {text}
        </div>
      </div>
    );
  };
  return (
    <>
      <div className="card bg-transparent border-0">
        {/* Card header START */}
        <div
          className="d-flex d-md-none flex-column"
          style={{ padding: "0px 6px" }}
        >
          {allSubSubCategory?.length > 0 && (
            <div
              style={{
                padding: "10px 0px",
              }}
            >
              <div
                className="d-flex hiddenScrollbar"
                style={{
                  overflowX: "auto",
                  whiteSpace: "nowrap",
                  gap: "8px",
                }}
              >
                {allSubSubCategory?.map((data) => (
                  <div
                    className="btn btn-sm rounded-2"
                    style={{
                      color: `#000000`,
                      backgroundColor: `#F4F9FF`,
                      fontWeight: "400",
                      fontSize: "14px",
                      paddingInline: "12px",
                    }}
                    onClick={() => {
                      setGender([data?.gender]);
                      setSubCategory([data?.subSubCategory]);
                      setBrandFilter({
                        brand: [],
                        color: color,
                        size: size,
                        category: [data?.gender],
                        subCategory: category,
                        subSubCategory: [data?.subSubCategory],
                        minprice: range[0],
                        maxprice: range[1],
                      });
                    }}
                  >
                    {data?.gender} - {data?.subSubCategoryDisplayName}
                  </div>
                ))}
              </div>
            </div>
          )}
          <div
            className="d-flex hiddenScrollbar"
            style={{
              gap: "8px",
              padding: "10px 0px",
              overflowX: "auto",
              whiteSpace: "nowrap",
            }}
          >
            <div
              style={{
                padding: "10px 32px",
                height: "28px",
                gap: "10px",
                borderRadius: "8px",
                borderWidth: "1px",
                border: "1px solid #005FDA",
              }}
              className="d-flex align-items-center justify-content-center"
              onClick={() => {
                setShowTray(true);
                setFilterOption("gender");
              }}
            >
              <div
                style={{
                  fontFamily: "Inter",
                  fontWeight: "400",
                  fontSize: "14px",
                  lineHeight: "100%",
                  letterSpacing: "0%",
                  color: "#005FDA",
                }}
              >
                Filter
              </div>
            </div>
            {BrandFilter.category.length > 0 &&
              BrandFilterOption("gender", "Gender")}
            {BrandFilter.subCategory.length > 0 &&
              BrandFilterOption("category", "Category")}
            {BrandFilter.subSubCategory.length > 0 &&
              BrandFilterOption("subCategory", "Sub-Category")}
            {(BrandFilter.minprice !== 0 || BrandFilter.maxprice !== 90000) >
              0 && BrandFilterOption("price", "Price")}
            {BrandFilter.size.length > 0 && BrandFilterOption("size", "Size")}
            {BrandFilter.color.length > 0 &&
              BrandFilterOption("color", "Color")}
            {sortBy !== "NF" && BrandFilterOption("sort", "Sort By")}
          </div>
        </div>
        <div className="d-none d-md-flex flex-column gap-3">
          {allSubSubCategory && allSubSubCategory.length > 0 && (
            <div
              className="d-flex gap-3 hiddenScrollbar"
              style={{ overflow: "auto", whiteSpace: "nowrap" }}
            >
              {allSubSubCategory.map((data) => (
                <div
                  className="btn btn-sm rounded-2"
                  style={{
                    color: `#005FDA`,
                    backgroundColor: `#F5F5F5`,
                  }}
                  onClick={() => {
                    setGender([data?.gender]);
                    setSubCategory([data?.subSubCategory]);
                    setBrandFilter({
                      brand: [],
                      color: color,
                      size: size,
                      category: [data?.gender],
                      subCategory: category,
                      subSubCategory: [data?.subSubCategory],
                      minprice: range[0],
                      maxprice: range[1],
                    });
                  }}
                >
                  {data?.gender} - {data?.subSubCategoryDisplayName}
                </div>
              ))}
            </div>
          )}
          <div className="d-flex align-items-center gap-3 mb-3">
            <div
              style={{
                cursor: "pointer",
                height: "40px",
                padding: "10px 24px",
                gap: "10px",
                borderRadius: "12px",
                borderWidth: "1px",
                border: "1px solid #005FDA",
              }}
              className="d-flex align-items-center justify-content-center"
              onClick={() => {
                setShowModal(true);
                setFilterOption("gender");
              }}
            >
              <div
                style={{
                  fontFamily: "Inter",
                  fontWeight: "400",
                  fontSize: "14px",
                  lineHeight: "100%",
                  letterSpacing: "0%",
                  color: "#005FDA",
                  whiteSpace: "nowrap",
                }}
              >
                Filters
              </div>
            </div>
            {BrandFilter.category.length > 0 &&
              BrandFilterOption("gender", "Gender")}
            {BrandFilter.subCategory.length > 0 &&
              BrandFilterOption("category", "Category")}
            {BrandFilter.subSubCategory.length > 0 &&
              BrandFilterOption("subCategory", "Sub-Category")}
            {(BrandFilter.minprice !== 0 || BrandFilter.maxprice !== 90000) >
              0 && BrandFilterOption("price", "Price")}
            {BrandFilter.size.length > 0 && BrandFilterOption("size", "Size")}
            {BrandFilter.color.length > 0 &&
              BrandFilterOption("color", "Color")}
            {sortBy !== "NF" && BrandFilterOption("sort", "Sort By")}
          </div>
        </div>

        {/* Card body START */}
        <div className="card-body p-0 mx-1 mx-lg-0">
          <div className="row mx-0">
            {/* Product item START */}
            {loading
              ? Array.from({ length: 15 }).map((_, index) => (
                <div
                  key={`skeleton-${index}`}
                  className={`col-6 col-sm-4 col-md-3 col-lg-20 ${index % 2 === 0 ? "ps-0 pe-1" : "ps-1 pe-0"
                    } px-md-1 mt-2 mt-lg-1`}
                >
                  <Skeleton />
                </div>
              ))
              : filteredProducts.map((product, index) => (
                <ProductCard9 product={product} />
              ))}

            {/* Product item END */}
          </div>
        </div>
        {/* Card body END */}

        {/*} Pagination */}
      </div>

      <button
        className={`btn btn-loader  mt-12  btn-primary-soft ${loading ||
            !countLeft ||
            filteredProducts.length < currentPage * itemsPerPage
            ? "disabled"
            : ""
          }`}
        onClick={
          !countLeft
            ? null
            : () => {
              if (!loading) {
                setLoading(true);
                setCurrentPage((prevValue) => prevValue + 1);
              }
            }
        }
      >
        {loading ? (
          <div class="spinner-grow spinner-grow-sm" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        ) : (
          <span className="load-text">
            {filteredProducts.length >= currentPage * itemsPerPage
              ? "Load more"
              : "No more products to show"}
          </span>
        )}
      </button>
      <style jsx>
        {`
          .brandProductsModal .modal-dialog {
            // max-width: 58.5rem;
            max-width: 45rem;
          }
          .selected {
            background-color: rgb(0, 95, 218);
            color: white;
            // color: rgb(0, 95, 218);
            // background-color: rgb(228, 233, 239);
          }
        `}
      </style>
      <BottomTray isOpen={showTray} setIsOpen={setShowTray} text={"Filter"}>
        <FilterTray
          filterOption={filterOption}
          setFilterOption={setFilterOption}
          availableGenders={availableGenders}
          gender={gender}
          category={category}
          subCategory={subCategory}
          subSubCategory={subSubCategory}
          displaySubCatMap={displaySubCatMap}
          range={range}
          size={size}
          alphabeticSizes={alphabeticSizes}
          availableSizes={availableSizes}
          numericSizes={numericSizes}
          sortBy={sortBy}
          sortOptions={sortOptions}
          setSortBy={setSortBy}
          handleGenderChange={handleGenderChange}
          handleCategoryChange={handleCategoryChange}
          handleSubCategoryChange={handleSubCategoryChange}
          handleRangeChange={handleRangeChange}
          handleMinInputChange={handleMinInputChange}
          handleMaxInputChange={handleMaxInputChange}
          handleSizeChange={handleSizeChange}
          handleClose={handleClose}
          resetBrandFilter={resetBrandFilter}
          handleApplyFilter={handleApplyFilter}
        />
      </BottomTray>
      <FilterModal
        showModal={showModal}
        filterOption={filterOption}
        setFilterOption={setFilterOption}
        availableGenders={availableGenders}
        gender={gender}
        category={category}
        subCategory={subCategory}
        subSubCategory={subSubCategory}
        displaySubCatMap={displaySubCatMap}
        range={range}
        size={size}
        alphabeticSizes={alphabeticSizes}
        availableSizes={availableSizes}
        numericSizes={numericSizes}
        sortBy={sortBy}
        sortOptions={sortOptions}
        setSortBy={setSortBy}
        handleGenderChange={handleGenderChange}
        handleCategoryChange={handleCategoryChange}
        handleSubCategoryChange={handleSubCategoryChange}
        handleRangeChange={handleRangeChange}
        handleMinInputChange={handleMinInputChange}
        handleMaxInputChange={handleMaxInputChange}
        handleSizeChange={handleSizeChange}
        handleClose={handleClose}
        resetBrandFilter={resetBrandFilter}
        handleApplyFilter={handleApplyFilter}
      />
    </>
  );
}

export default BrandProducts3;
